/**
 * Sign Up Form Dropdowns
 * 
 * Populates the hospital and ward dropdowns in Registration Magic forms
 * with data from the Hospital CPT
 */

(function($) {
    'use strict';

    /**
     * Populate hospital dropdown with data from database
     */
    function populateHospitalDropdown(callback) {
        const $hospitalDropdown = $('.RM_hospital_dropdown');
        const $wardDropdown = $('.RM_ward_dropdown');
        
        // Exit if hospital dropdown doesn't exist
        if ($hospitalDropdown.length === 0) {
            return;
        }

        // Disable ward dropdown initially
        if ($wardDropdown.length > 0) {
            $wardDropdown.prop('disabled', true);
            $wardDropdown.html('<option value="">Select a hospital first</option>');
        }

        // Show loading state
        $hospitalDropdown.prop('disabled', true);
        $hospitalDropdown.html('<option value="">Loading hospitals...</option>');

        // Fetch hospitals from REST API
        $.ajax({
            url: mchriFormData.restUrl + 'mchri/v1/hospitals',
            method: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', mchriFormData.nonce);
            },
            success: function(hospitals) {
                
                // Clear loading message
                $hospitalDropdown.empty();
                
                // Add default option
                $hospitalDropdown.append('<option value="">Select a hospital</option>');
                
                // Add hospital options
                hospitals.forEach(function(hospital) {
                    const option = $('<option></option>')
                        .attr('value', hospital.id)
                        .text(hospital.name);
                    $hospitalDropdown.append(option);
                });
                
                // Re-enable dropdown
                $hospitalDropdown.prop('disabled', false);

                // RM's "Enable search" option wraps this select in Select2,
                // which renders a copy of the selection — refresh it so it
                // doesn't keep showing the "Loading hospitals..." option.
                // change.select2 re-renders without firing change.mchri.
                $hospitalDropdown.trigger('change.select2');

                // Call callback if provided
                if (typeof callback === 'function') {
                    callback();
                }
            },
            error: function(xhr, status, error) {
                console.error('MCHRI: Error fetching hospitals:', error);
                
                // Show error message
                $hospitalDropdown.html('<option value="">Error loading hospitals</option>');
                $hospitalDropdown.prop('disabled', false);
            }
        });
    }

    /**
     * Populate ward dropdown based on selected hospital
     */
    function populateWardDropdown(hospitalId, callback) {
        const $wardDropdown = $('.RM_ward_dropdown');
        
        // Exit if ward dropdown doesn't exist
        if ($wardDropdown.length === 0) {
            return;
        }

        // If no hospital selected, disable and reset ward dropdown
        if (!hospitalId) {
            $wardDropdown.prop('disabled', true);
            $wardDropdown.html('<option value="">Select a hospital first</option>');
            return;
        }

        // Show loading state
        $wardDropdown.prop('disabled', true);
        $wardDropdown.html('<option value="">Loading options...</option>');

        // Fetch wards from REST API
        $.ajax({
            url: mchriFormData.restUrl + 'mchri/v1/hospitals/' + hospitalId + '/wards',
            method: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', mchriFormData.nonce);
            },
            success: function(wards) {
                
                // Clear loading message
                $wardDropdown.empty();
                
                // Add default option
                $wardDropdown.append('<option value="">Please select</option>');
                
                // Add ward options
                if (wards.length > 0) {
                    wards.forEach(function(ward) {
                        const option = $('<option></option>')
                            .attr('value', ward.id)
                            .text(ward.name);
                        $wardDropdown.append(option);
                    });
                    
                    // Enable dropdown
                    $wardDropdown.prop('disabled', false);
                    
                    // Call callback if provided
                    if (typeof callback === 'function') {
                        callback();
                    }
                } else {
                    // No wards available
                    $wardDropdown.html('<option value="">No options available</option>');
                    $wardDropdown.prop('disabled', true);
                }
            },
            error: function(xhr, status, error) {
                console.error('MCHRI: Error fetching wards:', error);
                
                // Show error message
                $wardDropdown.html('<option value="">Error loading options</option>');
                $wardDropdown.prop('disabled', true);
            }
        });
    }

    /**
     * Setup event listeners
     */
    function setupEventListeners() {
        const $hospitalDropdown = $('.RM_hospital_dropdown');
        
        // Listen for hospital selection changes
        $hospitalDropdown.off('change.mchri').on('change.mchri', function() {
            const hospitalId = $(this).val();
            populateWardDropdown(hospitalId);
        });
    }

    /**
     * Get query string parameter by name
     */
    function getQueryParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    /**
     * Auto-populate dropdowns from query string parameters
     */
    function autoPopulateFromQueryString() {
        const hospitalId = getQueryParam('hospital');
        const wardId = getQueryParam('ward');
        
        if (!hospitalId) {
            return;
        }
        
        const $hospitalDropdown = $('.RM_hospital_dropdown');
        
        // Check if hospital option exists
        if ($hospitalDropdown.find('option[value="' + hospitalId + '"]').length > 0) {
            // change.select2 updates the Select2 rendering without firing the
            // change.mchri handler (wards are loaded explicitly below)
            $hospitalDropdown.val(hospitalId).trigger('change.select2');

            // If ward ID is also present, load wards and then select
            if (wardId) {
                
                // Populate wards for the selected hospital, then select the ward
                populateWardDropdown(hospitalId, function() {
                    const $wardDropdown = $('.RM_ward_dropdown');
                    if ($wardDropdown.find('option[value="' + wardId + '"]').length > 0) {
                        $wardDropdown.val(wardId);
                    } else {
                        console.warn('MCHRI: Ward ID not found in dropdown:', wardId);
                    }
                });
            } else {
                // Just trigger change to load wards (but don't auto-select)
                $hospitalDropdown.trigger('change');
            }
        } else {
            console.warn('MCHRI: Hospital ID not found in dropdown:', hospitalId);
        }
    }

    /**
     * Initialize dropdowns
     */
    function initializeDropdowns() {
        const $hospitalDropdown = $('.RM_hospital_dropdown');

        // rm_form_loaded also fires for the form that was already on the page at
        // document ready; repopulating it then wipes a hospital the user has
        // already picked. A form RM swaps in is a new element without the flag.
        if ($hospitalDropdown.data('mchriInitialised')) {
            return;
        }
        $hospitalDropdown.data('mchriInitialised', true);

        // Populate hospital dropdown first, then check query string after it's loaded
        populateHospitalDropdown(function() {
            // Hospital dropdown is now populated, check for query string parameters
            autoPopulateFromQueryString();
        });
        
        setupEventListeners();
    }

    /**
     * Initialize when DOM is ready
     */
    $(document).ready(function() {
        
        // Initialize dropdowns
        initializeDropdowns();
        
        // Re-initialize if Registration Magic dynamically loads forms
        $(document).on('rm_form_loaded', function() {
            initializeDropdowns();
        });
    });

})(jQuery);

